<template>
  <nav
    class="sidebar-component-container"
    :class="{ mastery: isMastery }"
  >
    <div class="bar">
      <menu-list
        :mastery="isMastery"
        :navigation-items="navigationItems"
        :on-tour="onTour"
      />
      <menu-footer
        :on-tour="onTour"
      />
    </div>
  </nav>
</template>

<script>
import MenuFooter from '@components/ui/menu/footer';
import MenuList from '@components/ui/menu/list';

export default {
  components: { MenuFooter, MenuList },
  computed: {
    isMastery() {
      return this.$store.getters['app/isMasteryApp'];
    },
    onTour() {
      return this.$store.getters['session/onTour'];
    },
    navigationItems() {
      return this.$store.getters['navigationItems/menuItems'];
    },
  },
};
</script>

<style lang='scss' scoped>
  $sidebar-background: $flat-dark !default;

  .sidebar-component-container {
    bottom: 0;
    overflow: hidden;
    position: absolute;
    top: rem-calc(48);
    width: rem-calc(220);

    @include breakpoint(small) {
      width: 0;
    }

    .bar {
      background-color: $sidebar-background;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      height: 100%;
      text-align: center;
      z-index: 1;
      overflow: hidden;
      padding: rem-calc(6);
    }

    &.mastery {
      .bar {
        background-color: #fafafa;
      }
    }
  }
</style>
